export default {
  methods: {
    $openModal(name, data, options = {}) {
      this.$store.dispatch('modals/openModal', {
        data,
        name,
        closeModal: options.closeModal,
        isLocked: options.isLocked,
        isRequired: options.isRequired
      });
    },

    $closeModal(name) {
      this.$store.dispatch('modals/closeModal', name);
    },

    $closeAllModals() {
      this.$store.dispatch('modals/closeAllModals');
    },

    $lockModal(name) {
      this.$store.dispatch('modals/lockModal', name);
    },

    $unlockModal(name) {
      this.$store.dispatch('modals/unlockModal', name);
    },

    async $modalIsOpen() {
      /*
        NOTE: We need to wait a few ticks to give modals that are currently open
        a chance to close themselves before checking if any are open.
      */

      await this.$nextTick();
      await this.$nextTick();
      await this.$nextTick();

      return this.$store.dispatch('modals/modalIsOpen');
    }
  }
};
